import React from 'react';
import {useDispatch} from 'react-redux';
import querystring from 'querystring';
import {deselectItem, selectItem} from '../../../actions/comment/comment';
import classnames from 'classnames';
import ItemCheckbox from "../../common/CommentItemCheckbox";
import {ipMasking} from '../../../utils/formatter';
import {Link} from 'react-router-dom'
import CommentListItemButton from "./CommentListItemButton";
import {addPrefix} from "../../../utils/UriUtil";
import {TISTORY} from "../../../constants/Service"

// Title Render
function Title({item}) {
  function linkToComment(e, item) {
    if (item.deleting) {
      e.preventDefault()
    }
  }

  return (
    <strong className="tit_post">
      <a href={addPrefix(`/${item.entryId}#comment${item.id}`)} target="_blank" className="link_cont" onClick={(e) => linkToComment(e, item)}>
        {item.parent !== null && <span className="info_status">[답글]</span>}
        {item.comment}
        {item.secret && <span className="ico_blog ico_security"/>}
      </a>
    </strong>
  )
}

// Author Render
function Author({item}) {
  const query = {
    searchKeyword: item.author.substring(1, item.author.length),
    searchType: 'writer'
  }

  if (window.Config.service === TISTORY ) {
    return (
      <Link to={"/comments?" + querystring.stringify(query)}>
        <span className="txt_cate">{item.author}</span>
      </Link>
    )
  } else {
    return (
      <span className="txt_cate">{item.author}</span>
    )
  }

}

export default function CommentListItem({item}) {
  const dispatch = useDispatch()

  function handleSelect(e) {
    if (item.selected) {
      dispatch(deselectItem(item.id))
    } else {
      dispatch(selectItem(item.id))
    }
  }

  return (
    <li className={classnames({item_dimmed: item.deleting})}>
      <ItemCheckbox item={item} handleSelect={handleSelect}/>
      <div className="post_cont">
        <Author item={item}/>
        <span className="txt_info txt_info_type1 txt fst">{ipMasking(item.ip)}</span>
        <span className="txt_info txt_info_type1">{item.written}</span>
        <Title item={item}/>
        <span className="txt_info txt_ellip fst"><span className="ico_blog ico_post"/>{item.entryTitle}</span>
      </div>
      <div className="post_btn">
        <div className="info_btn">
          <CommentListItemButton item={item}/>
        </div>
      </div>
    </li>
  )
}
